package org.braunequip.web.components.forms

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Resize
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.layout.HorizontalDivider
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.defer.Deferred
import gr.tech.lkpksignature.components.SignaturePad.SignatureCanvas
import gr.tech.lkpksignature.components.SignaturePad.clearSigPad
import gr.tech.lkpksignature.components.SignaturePad.loadSigPad
import gr.tech.lkpksignature.components.SignaturePad.saveSigPad
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.braunequip.web.components.models.DieselFuelLogDTO
import org.braunequip.web.components.models.DieselType
import org.braunequip.web.styles.noBorder
import org.braunequip.web.util.Constants.FONT_FAMILY
import org.braunequip.web.util.Constants.FONT_FAMILY2
import org.braunequip.web.util.InputIDs
import org.braunequip.web.util.Theme
import org.braunequip.web.util.submitDieselLogForm
import org.braunequip.web.util.submitTimeOffRequest
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.name
import org.jetbrains.compose.web.attributes.placeholder
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.*
import org.w3c.dom.HTMLInputElement
import org.w3c.dom.HTMLTextAreaElement

@Composable
fun DieselLogForm(
    scope: CoroutineScope,
    onFinish: () -> Unit
) {
    var errorText by remember { mutableStateOf(" ") }
    var DieselLogState by remember { mutableStateOf(DieselFuelLogDTO()) }

    Deferred {
        loadSigPad()
    }

    H3(Modifier.classNames("title", "is-3", "has-text-dark").toAttrs()) {
        Text("Diesel Fuel Log Form")
    }

    Row(
        modifier = Modifier
            .margin(topBottom = 12.px)
            .fillMaxWidth()
            .gap(20.px)
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
        ) {
            SpanText(
                text = "Diesel Type *",
                modifier = Modifier
                    .margin(right = 10.px)
                    .fontWeight(FontWeight.Bold)
            )


            Row(
                modifier = Modifier
                    .fillMaxWidth(),
                horizontalArrangement = Arrangement.Start,
                verticalAlignment = Alignment.CenterVertically
            )  {
                Input(
                    type = InputType.Radio,
                    attrs = Modifier
                        .id(InputIDs.DieselLogForm.dieseltypeDyed)
                        .margin(right = 15.px)
                        .height(20.px)
                        .border(
                            width = 1.px,
                            style = LineStyle.Solid,
                            color = Colors.Black
                        )
                        .toAttrs {
                            attr("placeholder", "")
                            name(InputIDs.DieselLogForm.dieselName)
                            value(DieselType.dyed.toString())
                            checked(true)
                        }
                )

                Label(
                    forId = InputIDs.DieselLogForm.dieseltypeDyed,
                    attrs = Modifier
                        .fontFamily(FONT_FAMILY2)
                        .fontSize(16.px)
                        .toAttrs()
                ) {
                    Text(DieselType.dyed.toString())
                }
            }

            Row(
                modifier = Modifier
                    .fillMaxWidth(),
                horizontalArrangement = Arrangement.Start,
                verticalAlignment = Alignment.CenterVertically
            )  {
                Input(
                    type = InputType.Radio,
                    attrs = Modifier
                        .id(InputIDs.DieselLogForm.dieseltypeClear)
                        .margin(right = 15.px)
                        .height(20.px)
                        .border(
                            width = 1.px,
                            style = LineStyle.Solid,
                            color = Colors.Black
                        )

                        .toAttrs {
                            attr("placeholder", "")
                            name(InputIDs.DieselLogForm.dieselName)
                            value(DieselType.clear.toString())
                        }
                )

                Label(
                    forId = InputIDs.DieselLogForm.dieseltypeClear,
                    attrs = Modifier
                        .fontFamily(FONT_FAMILY2)
                        .fontSize(16.px)
                        .toAttrs()
                ) {
                    Text(DieselType.clear.toString())
                }
            }



        }
    }

    Row(
        modifier = Modifier
            .fillMaxWidth()
            .gap(20.px)
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
        ) {
            SpanText(
                text = "Name*",
                modifier = Modifier
                    .margin(right = 10.px)
                    .fontWeight(FontWeight.Bold)
            )

            Input(
                type = InputType.Text,
                attrs = Modifier
                    .id(InputIDs.DieselLogForm.name)
                    .fillMaxWidth()
                    .height(54.px)
                    .margin(topBottom = 12.px)
                    .padding(leftRight = 20.px)
                    .backgroundColor(Theme.LightGray.rgb)
                    .borderRadius(r = 4.px)
                    .border(
                        width = 1.px,
                        style = LineStyle.Solid,
                        color = Colors.Black
                    )
                    .fontFamily(FONT_FAMILY2)
                    .fontSize(16.px)
                    .toAttrs {
                        attr("placeholder", "")
                    }
            )
        }

    }

    Row(
        modifier = Modifier
            .fillMaxWidth(),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
        ) {
            SpanText(
                text = "Date*",
                modifier = Modifier
                    .margin(right = 10.px)
                    .fontWeight(FontWeight.Bold)
            )

            Input(
                type = InputType.Date,
                attrs = Modifier
                    .id(InputIDs.DieselLogForm.date)
                    .fillMaxWidth()
                    .height(54.px)
                    .margin(topBottom = 12.px)
                    .padding(leftRight = 20.px)
                    .backgroundColor(Theme.LightGray.rgb)
                    .borderRadius(r = 4.px)
                    .border(
                        width = 1.px,
                        style = LineStyle.Solid,
                        color = Colors.Black
                    )
                    .fontFamily(FONT_FAMILY2)
                    .fontSize(16.px)
                    .toAttrs()
            )
        }
    }

    Row(
        modifier = Modifier
            .fillMaxWidth()
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
        ) {
            //TODO change this to a dropdown of available assets once available?
            SpanText(
                text = "Equipment ID*",
                modifier = Modifier
                    .margin(right = 10.px)
                    .fontWeight(FontWeight.Bold)
            )

            Input(
                type = InputType.Text,
                attrs = Modifier
                    .id(InputIDs.DieselLogForm.equipmentid)
                    .fillMaxWidth()
                    .height(54.px)
                    .margin(topBottom = 12.px)
                    .padding(leftRight = 20.px)
                    .backgroundColor(Theme.LightGray.rgb)
                    .borderRadius(r = 4.px)
                    .border(
                        width = 1.px,
                        style = LineStyle.Solid,
                        color = Colors.Black
                    )
                    .fontFamily(FONT_FAMILY2)
                    .fontSize(16.px)
                    .toAttrs {
                        attr("placeholder", "Truck 23, Water Truck 1, Pickup 3, etc.")
                    }
            )
        }
    }


    Row(
        modifier = Modifier
            .fillMaxWidth()
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth(),
            horizontalAlignment = Alignment.Start
        ) {
            SpanText(
                text = "Starting Meter *",
                modifier = Modifier
                    .margin(right = 10.px)
                    .fontWeight(FontWeight.Bold)
            )

            SpanText(
                text = "(small total gallon number below meter)",
                modifier = Modifier
                    .margin(right = 10.px)
                    .fontWeight(FontWeight.Light)
            )

            Input(
                type = InputType.Number,
                attrs = Modifier
                    .id(InputIDs.DieselLogForm.startingmeter)
                    .height(54.px)
                    .width(250.px)
                    .margin(topBottom = 12.px)
                    .padding(leftRight = 20.px)
                    .backgroundColor(Theme.LightGray.rgb)
                    .borderRadius(r = 4.px)
                    .border(
                        width = 1.px,
                        style = LineStyle.Solid,
                        color = Colors.Black
                    )
                    .fontFamily(FONT_FAMILY2)
                    .fontSize(16.px)
                    .toAttrs{
                        placeholder("ex. 23")
                    }
            )

        }
    }

    Row(
        modifier = Modifier
            .fillMaxWidth()
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth(),
            horizontalAlignment = Alignment.Start
        ) {
            SpanText(
                text = "Ending Meter *",
                modifier = Modifier
                    .margin(right = 10.px)
                    .fontWeight(FontWeight.Bold)
            )

            SpanText(
                text = "(small total gallon number below meter)",
                modifier = Modifier
                    .margin(right = 10.px)
                    .fontWeight(FontWeight.Light)
            )

            Input(
                type = InputType.Number,
                attrs = Modifier
                    .id(InputIDs.DieselLogForm.endingmeter)
                    .height(54.px)
                    .width(250.px)
                    .margin(topBottom = 12.px)
                    .padding(leftRight = 20.px)
                    .backgroundColor(Theme.LightGray.rgb)
                    .borderRadius(r = 4.px)
                    .border(
                        width = 1.px,
                        style = LineStyle.Solid,
                        color = Colors.Black
                    )
                    .fontFamily(FONT_FAMILY2)
                    .fontSize(16.px)
                    .toAttrs{
                        placeholder("ex. 23")
                    }
            )

        }
    }

    Row(
        modifier = Modifier
            .fillMaxWidth()
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth(),
            horizontalAlignment = Alignment.Start
        ) {
            SpanText(
                text = "Total Gallons",
                modifier = Modifier
                    .margin(right = 10.px)
                    .fontWeight(FontWeight.Bold)
            )

            Input(
                type = InputType.Number,
                attrs = Modifier
                    .id(InputIDs.DieselLogForm.totalgallons)
                    .height(54.px)
                    .width(250.px)
                    .margin(topBottom = 12.px)
                    .padding(leftRight = 20.px)
                    .backgroundColor(Theme.LightGray.rgb)
                    .borderRadius(r = 4.px)
                    .border(
                        width = 1.px,
                        style = LineStyle.Solid,
                        color = Colors.Black
                    )
                    .fontFamily(FONT_FAMILY2)
                    .fontSize(16.px)
                    .toAttrs{
                        placeholder("ex. 23")
                    }
            )

        }
    }

    Column(
        modifier = Modifier
            .fillMaxWidth(),
        horizontalAlignment = Alignment.Start,
    ) {
        SpanText(
            text = "Signature *",
            modifier = Modifier
                .margin(right = 10.px)
                .fontWeight(FontWeight.Bold)
        )
        SignatureCanvas()
        Button(
            attrs = Modifier
                .onClick { clearSigPad() }
                .width(54.px)
                .height(24.px)
                .margin(top = 4.px)
                .backgroundColor(Theme.LightGray.rgb)
                .color(Colors.Black)
                .borderRadius(4.px)
                .border(
                    width = 1.px,
                    style = LineStyle.Solid,
                    color = Colors.Black
                )
                .fontFamily(FONT_FAMILY2)
                .fontSize(16.px)
                .toAttrs()
        ) {
            SpanText(text = "Clear")
        }
    }


    SpanText(
        modifier = Modifier
            .width(350.px)
            .margin(top = 1.cssRem)
            .fontFamily(FONT_FAMILY2)
            .color(Colors.Black)
            .textAlign(TextAlign.Center),
        text = errorText
    )


    SubmitButton(
        text = "SUBMIT",
        onClick = {
            // Retrieve NUMBER input values from the HTML elements
            val startingMeterInput = (document.getElementById(InputIDs.DieselLogForm.startingmeter) as HTMLInputElement).value
            val endingMeterInput = (document.getElementById(InputIDs.DieselLogForm.endingmeter) as HTMLInputElement).value
            val totalGallonsInput = (document.getElementById(InputIDs.DieselLogForm.totalgallons) as HTMLInputElement).value

            //Convert them to int or they will be null.
            val startingMeter = startingMeterInput.toIntOrNull()
            val endingMeter = endingMeterInput.toIntOrNull()
            val totalGallons = totalGallonsInput.toIntOrNull()

            //Signature
            val signedSignature = saveSigPad()

            if (
                startingMeter != null &&
                endingMeter != null &&
                totalGallons != null
            ) {
                DieselLogState = DieselLogState.copy(
                    dieselType = DieselType.fromLiteral((document.querySelector("input[name='dieseltypename']:checked") as HTMLInputElement).value),
                    name = (document.getElementById(InputIDs.DieselLogForm.name) as HTMLInputElement).value,
                    date = (document.getElementById(InputIDs.DieselLogForm.date) as HTMLInputElement).value,
                    equipmentId = (document.getElementById(InputIDs.DieselLogForm.equipmentid) as HTMLInputElement).value,
                    startingMeter = startingMeter,
                    endingMeter = endingMeter,
                    totalGallons = totalGallons,
                    signature = signedSignature
                )

                if (
                    DieselLogState.name.isNotEmpty() &&
                    DieselLogState.date.isNotEmpty() &&
                    DieselLogState.equipmentId.isNotEmpty() &&
                    DieselLogState.signature != null
                ) {
                    errorText = " "

                    scope.launch {
                        submitDieselLogForm(
                            dieselFuelLogDTO = DieselLogState
                        ) { finishText ->
                            errorText = finishText
                        }
                        delay(1000)
                        onFinish()
                    }

                } else {
                    errorText = "Please fill out all required fields."
                }
            } else {
                errorText = "Please input valid numbers."
            }
        }
    )
}